import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// o import() fica dentro da condição constante: no build de produção ela vira
// false e a demo (com dados falsos) nem entra como chunk
const DemoVitrines =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_SHOWCASES_DEMO === 'true'
    ? React.lazy(() => import('./modules/RecommendationShowcases/Demo'))
    : null;

ReactDOM.render(
  <React.StrictMode>
    {DemoVitrines ? (
      <React.Suspense fallback={<p>Carregando demonstração…</p>}>
        <DemoVitrines />
      </React.Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
